/* eslint-disable react/display-name */
import * as React from 'react';

const Phone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g>
      <path
        d="M10,8.41a3.15,3.15,0,0,1,2-.22H12l2.82.65A1.55,1.55,0,0,1,16,10.51l-.42,4.11A1.54,1.54,0,0,1,14,16l-.25,0A14.31,14.31,0,0,1,4.2,11.79,14.54,14.54,0,0,1,0,2.45L0,2.2A1.55,1.55,0,0,1,1.32.58L5.26,0A1.54,1.54,0,0,1,7,1.16l.76,3s0,.05,0,.07a3.31,3.31,0,0,1-.18,1.87l-.1.28a8.84,8.84,0,0,0,1,1.2,8.13,8.13,0,0,0,1.13,1Zm.77,1.69h0l-1.32.57L9,10.4A11.08,11.08,0,0,1,7.16,8.91,11.27,11.27,0,0,1,5.66,7l-.25-.39.44-1.2v0a1.37,1.37,0,0,0,.07-.8L5.24,1.9l-3.36.48a12.67,12.67,0,0,0,3.64,8.1,12.46,12.46,0,0,0,8.23,3.64l.36-3.52L11.57,10A1.35,1.35,0,0,0,10.75,10.1Z"
        style={{ fill: 'inherit' }}
      />
    </g>
  </svg>
);

export default Phone;
